export default __webpack_public_path__ + "static/media/maincookie.7791e83e.svg";